import {type ClassValue, clsx} from 'clsx';

/**
 * Утилита для объединения CSS классов
 * Использует clsx для условного объединения классов
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
